type Dictionary<T> = { [key: string]: T };

interface SavedRoute {
  name?: string;
  query?: Dictionary<string | string[]>;
  fullPath?: string;
  title?: string;
  params?: Dictionary<string>;
}
export { SavedRoute };

export enum ContactsKeyType {
  Media_company = 'media_company',
  Decision_maker = 'decision_maker',
  Technical = 'technical',
  Marketing = 'marketing',
}

export type Contact = {
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  availability: string;
  is_copy_of_dm: string;
};

export type Contacts = {
  [key in ContactsKeyType]: Contact;
};
